<div style=" padding: 20px" class="delete_container text-center fc_DEDEDE">
  <h4 style="margin-top: 0;">Are you sure to delete this {{data.isPackage ? 'H&L package' : 'project'}}?</h4>
  <div style="display: flex; justify-content: space-between">
    <button mat-button (click)="cancel()" class="cancel_button">Cancel</button>
    <button mat-button (click)="deleteProject()" class="delete_button">Delete</button>
  </div>
</div>